import React from 'react';
import { Routes, Route } from "react-router-dom";
import About from './components/About';
import Contact from './components/Contact';
import Experience from './components/Experience';
import Header from './components/Header';
import Landing from './components/Landing';
import Portfolio from './components/Portfolio';
import Service from './components/Service';
import { Analytics } from "@vercel/analytics/react";
import Education from './components/Education';

function App() {
  return (
    <>
      <Header />
      <Landing />
      <About />
      <Education/>
      <Service />
      <Experience />
      <Portfolio />
      <Contact />

      <Routes>
        <Route path="#landing" element={<Landing />} />
        <Route path="#about" element={<About />} />
        <Route path="#contact" element={<Contact />} />
        <Route path="#experience" element={<Experience />} />
        <Route path="#experience" element={<Portfolio />} />
        <Route path="#experience" element={<Experience />} />
        <Route path='#education' element={<Education/>}/>
      </Routes>
      <Analytics />
      <div className='last-text'>
        <p>Developed by Victor kinoti © 2023</p>
      </div>

      {/* <!---scroll-top---> */}
      <button className='top'>
        <i className='bx bx-up-arrow-alt'></i>
      </button>
    </>
  );
}

export default App;